<div class="details-container">
  <form class="new-agent-form" [formGroup]="form" (submit)="next()">
    <div class="form-content">
      <span class="title">{{ 'agent.details.title' | translate }}</span>
      <!-- Agent Name -->
      <div class="agent-name">
        <div class="standard-input">
          <label for="first_name">{{ 'agent.details.first_name' | translate }}</label>
          <input type="text" formControlName="first_name" placeholder="ex. Mario">
          <div class="error" *ngIf="form.get('first_name')?.invalid && (form.get('first_name')?.touched || form.get('first_name')?.dirty)">
            <small *ngIf="form.get('first_name')?.hasError('required')">{{ 'agent.validation.details_form.first_name.required' | translate }}</small>
          </div>
        </div>
        <div class="standard-input">
          <label for="last_name">{{ 'agent.details.last_name' | translate }}</label>
          <input type="text" formControlName="last_name" placeholder="ex. Rossi">
          <div class="error" *ngIf="form.get('last_name')?.invalid && (form.get('last_name')?.touched || form.get('last_name')?.dirty)">
            <small *ngIf="form.get('last_name')?.hasError('required')">{{ 'agent.validation.details_form.last_name.required' | translate }}</small>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="agent-email standard-input">
        <label for="email">{{ 'agent.details.email' | translate }}</label>
        <input type="email" formControlName="email" placeholder="ex. mario@domain.com">
        <div class="error" *ngIf="form.get('email')?.invalid && (form.get('email')?.touched || form.get('email')?.dirty)">
          <small *ngIf="form.get('email')?.hasError('required')">{{ 'agent.validation.details_form.email.required' | translate }}</small>
          <small *ngIf="form.get('email')?.hasError('invalidEmail')">{{ 'agent.validation.details_form.email.invalid' | translate }}</small>
        </div>
      </div>

      <!-- Phone -->
      <div class="agent-contact standard-input">
        <label for="phone">{{ 'agent.details.phone' | translate }}</label>
        <input type="text" formControlName="phone" placeholder="ex. +39 392 12345678">
        <div class="error" *ngIf="form.get('phone')?.invalid && (form.get('phone')?.touched || form.get('phone')?.dirty)">
          <small *ngIf="form.get('phone')?.hasError('required')">{{ 'agent.validation.details_form.phone.required' | translate }}</small>
          <small *ngIf="form.get('phone')?.hasError('pattern')">{{ 'agent.validation.details_form.phone.invalid' | translate }}</small>
        </div>
      </div>

      <!-- Country Selector + Address -->
      <div class="agent-location">
        <div class="agent-country standard-input">
          <label for="country">{{ 'agent.details.country' | translate }}</label>
          <input type="text"
                class="is-autocomplete"
                [placeholder]="'agent.details.select_placeholder' | translate"
                name="country"
                matInput
                formControlName="country"
                [matAutocomplete]="auto">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name">{{country.name}}</mat-option>
          </mat-autocomplete>
          <div class="error" *ngIf="form.get('country')?.invalid && (form.get('country')?.touched || form.get('country')?.dirty)">
            <small *ngIf="form.get('country')?.hasError('required')">{{ 'agent.validation.details_form.country.required' | translate }}</small>
            <small *ngIf="form.get('country')?.hasError('notFound')">{{ 'agent.validation.details_form.country.invalid' | translate }}</small>
          </div>
        </div>
        <div class="agent-address standard-input">
          <label for="address">{{ 'agent.details.address' | translate }}</label>
          <input type="text" formControlName="address" placeholder="ex. Viale Roma 23, Firenze" id="apartment" (focus)="addressAutoComplete()">
          <div class="error" *ngIf="form.get('address')?.invalid && (form.get('address')?.touched || form.get('address')?.dirty)">
            <small *ngIf="form.get('address')?.hasError('required')">{{ 'agent.validation.details_form.address.required' | translate }}</small>
          </div>
        </div>
      </div>

      <!-- VAT -->
      <div class="agent-vat standard-input">
        <label for="vat">{{ 'agent.details.vat' | translate }}</label>
        <input type="text" formControlName="vat" placeholder="ex. IT12345678910">
        <div class="error" *ngIf="form.get('vat')?.invalid && (form.get('vat')?.touched || form.get('vat')?.dirty)">
          <small *ngIf="form.get('vat')?.hasError('required')">{{ 'agent.validation.details_form.vat.required' | translate }}</small>
        </div>
      </div>

      <!-- Agents Portal Toggle -->
       <!-- TODO: Uncomment when agent portal is ready -->
      <div class="title" style="margin-top: 10px;">Agents portal</div>
      <div class="agent-access">
        <div class="agent-access-desc">
          <span class="title sub">{{ 'agent.details.access_toggle_title' | translate }}</span>
          <span class="desc">{{ 'agent.details.access_toggle_description' | translate }}</span>
        </div>
        <label class="switch">
          <input type="checkbox" formControlName="is_user">
          <span class="slider round"></span>
        </label>
      </div>

      <!-- Tags -->
      <div class="title" style="margin-top: 10px;">
        {{ 'agent.details.tags_title' | translate }}
        <span style="color: #868e96;">({{ 'agent.details.optional' | translate }})</span>
      </div>
      <div class="agent-tags">
        <span class="desc">{{ 'agent.details.tags_description' | translate }}</span>
        <mat-chip-list #chipList formControlName="tags">
          <mat-chip
            *ngFor="let tag of tags"
            [style.background-color]="tag.color"
            [selectable]="true"
            [removable]="true"
            (removed)="removeTag(tag)">
            {{ tag.name }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            placeholder="{{ 'agent.details.tags_placeholder' | translate }}"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addTag($event)" />
        </mat-chip-list>
      </div>
    </div>


    <div class="actions">
      <button type="submit" class="submit">
        {{ 'agent.actions.proceed' | translate }}
        <img src="assets/icones/arrow-right.svg" alt="">
      </button>
    </div>
  </form>
</div>
